import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthInitializer"] */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\components\\auth\\AuthInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaticDynamicRouterBinder"] */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\lib\\static-export-nav.tsx");
